/* eslint-disable */
// @ts-nocheck
/* -------------------------------------------------------------------------- */
/*                    GENERATED FILE, DO NOT EDIT MANUALLY!                   */
/* -------------------------------------------------------------------------- */

import { lazy, type LazyExoticComponent, type ReactElement } from "react";

interface Preview {
    component: LazyExoticComponent<() => ReactElement>;
}

export const Previews: Record<string, Preview> = {
    "tag/docs/tag/preview": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/preview.tsx"))
    },
    "tag/docs/tag/sizes": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/sizes.tsx"))
    },
    "tag/docs/tag/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/disabled.tsx"))
    },
    "tag/docs/tag/variants": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/variants.tsx"))
    },
    "tag/docs/tag/invalid": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/invalid.tsx"))
    },
    "tag/docs/tag/loading": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/loading.tsx"))
    },
    "tag/docs/tag/avatar": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/avatar.tsx"))
    },
    "tag/docs/tag/icons": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/icons.tsx"))
    },
    "tag/docs/tag/count": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/count.tsx"))
    },
    "tag/docs/tag/links": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/links.tsx"))
    },
    "tag/docs/tag/reactRouterLinks": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag/reactRouterLinks.tsx"))
    },
    "spinner/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/spinner/docs/preview.tsx"))
    },
    "spinner/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/spinner/docs/sizes.tsx"))
    },
    "spinner/docs/label": {
        component: lazy(() => import("@/../../packages/components/src/spinner/docs/label.tsx"))
    },
    "spinner/docs/overBackground": {
        component: lazy(() => import("@/../../packages/components/src/spinner/docs/overBackground.tsx"))
    },
    "badge/docs/floating-badge/preview": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/floating-badge/preview.tsx"))
    },
    "badge/docs/floating-badge/placement": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/floating-badge/placement.tsx"))
    },
    "badge/docs/floating-badge/overlap": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/floating-badge/overlap.tsx"))
    },
    "badge/docs/floating-badge/offset": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/floating-badge/offset.tsx"))
    },
    "callout/docs/compact": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/compact.tsx"))
    },
    "callout/docs/compactVariant": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/compactVariant.tsx"))
    },
    "callout/docs/compactLink": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/compactLink.tsx"))
    },
    "callout/docs/dismissableCompact": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/dismissableCompact.tsx"))
    },
    "callout/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/preview.tsx"))
    },
    "callout/docs/variant": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/variant.tsx"))
    },
    "callout/docs/noIcon": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/noIcon.tsx"))
    },
    "callout/docs/customIcon": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/customIcon.tsx"))
    },
    "callout/docs/notDismissable": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/notDismissable.tsx"))
    },
    "callout/docs/inline": {
        component: lazy(() => import("@/../../packages/components/src/callout/docs/inline.tsx"))
    },
    "badge/docs/badge/preview": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/badge/preview.tsx"))
    },
    "badge/docs/badge/disabled": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/badge/disabled.tsx"))
    },
    "badge/docs/badge/indeterminate": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/badge/indeterminate.tsx"))
    },
    "badge/docs/badge/variants": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/badge/variants.tsx"))
    },
    "badge/docs/badge/highCount": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/badge/highCount.tsx"))
    },
    "badge/docs/badge/text": {
        component: lazy(() => import("@/../../packages/components/src/badge/docs/badge/text.tsx"))
    },
    "header/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/header/docs/preview.tsx"))
    },
    "layout/docs/footer/preview": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/footer/preview.tsx"))
    },
    "layout/docs/content/preview": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/content/preview.tsx"))
    },
    "select/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/preview.tsx"))
    },
    "select/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/disabled.tsx"))
    },
    "select/docs/select-dropdown/disabled": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/disabled.tsx"))
    },
    "select/docs/error": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/error.tsx"))
    },
    "select/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/sizes.tsx"))
    },
    "select/docs/labeling": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/labeling.tsx"))
    },
    "select/docs/iconPrefix": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/iconPrefix.tsx"))
    },
    "select/docs/textPrefix": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/textPrefix.tsx"))
    },
    "select/docs/fluid": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/fluid.tsx"))
    },
    "select/docs/customValue": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/customValue.tsx"))
    },
    "select/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/controlled.tsx"))
    },
    "select/docs/form": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/form.tsx"))
    },
    "select/docs/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/ContextualHelp.tsx"))
    },
    "select/docs/select-dropdown/autoMenuWidth": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/autoMenuWidth.tsx"))
    },
    "select/docs/select-dropdown/menuPlacement": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/menuPlacement.tsx"))
    },
    "select/docs/select-dropdown/section": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/section.tsx"))
    },
    "select/docs/select-dropdown/footer": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/footer.tsx"))
    },
    "select/docs/select-dropdown/avatar": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/avatar.tsx"))
    },
    "select/docs/select-dropdown/count": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/count.tsx"))
    },
    "select/docs/select-dropdown/dynamicLists": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/dynamicLists.tsx"))
    },
    "select/docs/select-dropdown/icons": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/icons.tsx"))
    },
    "select/docs/select-dropdown/endIcons": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/endIcons.tsx"))
    },
    "select/docs/select-dropdown/loading": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/loading.tsx"))
    },
    "select/docs/select-dropdown/loadOnScroll": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/loadOnScroll.tsx"))
    },
    "select/docs/select-dropdown/selectionIndicator": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/selectionIndicator.tsx"))
    },
    "select/docs/select-dropdown/description": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/select-dropdown/description.tsx"))
    },
    "select/docs/filterable": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/filterable.tsx"))
    },
    "select/docs/multi-select": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/multi-select.tsx"))
    },
    "select/docs/multi-select-custom-value": {
        component: lazy(() => import("@/../../packages/components/src/select/docs/multi-select-custom-value.tsx"))
    },
    "combobox/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/preview.tsx"))
    },
    "combobox/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/disabled.tsx"))
    },
    "combobox/docs/combobox-option/disabled": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/disabled.tsx"))
    },
    "combobox/docs/error": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/error.tsx"))
    },
    "combobox/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/sizes.tsx"))
    },
    "combobox/docs/labeling": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/labeling.tsx"))
    },
    "combobox/docs/iconPrefix": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/iconPrefix.tsx"))
    },
    "combobox/docs/textPrefix": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/textPrefix.tsx"))
    },
    "combobox/docs/fluid": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/fluid.tsx"))
    },
    "combobox/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/controlled.tsx"))
    },
    "combobox/docs/customFiltering": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/customFiltering.tsx"))
    },
    "combobox/docs/allowEmptyCollection": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/allowEmptyCollection.tsx"))
    },
    "combobox/docs/allowCustomValue": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/allowCustomValue.tsx"))
    },
    "combobox/docs/form": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/form.tsx"))
    },
    "combobox/docs/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/ContextualHelp.tsx"))
    },
    "combobox/docs/combobox-option/autoMenuWidth": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/autoMenuWidth.tsx"))
    },
    "combobox/docs/combobox-option/menuPlacement": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/menuPlacement.tsx"))
    },
    "combobox/docs/combobox-option/section": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/section.tsx"))
    },
    "combobox/docs/combobox-option/footer": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/footer.tsx"))
    },
    "combobox/docs/combobox-option/avatar": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/avatar.tsx"))
    },
    "combobox/docs/combobox-option/count": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/count.tsx"))
    },
    "combobox/docs/combobox-option/dynamicLists": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/dynamicLists.tsx"))
    },
    "combobox/docs/combobox-option/icons": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/icons.tsx"))
    },
    "combobox/docs/combobox-option/endIcons": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/endIcons.tsx"))
    },
    "combobox/docs/combobox-option/loading": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/loading.tsx"))
    },
    "combobox/docs/combobox-option/loadOnScroll": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/loadOnScroll.tsx"))
    },
    "combobox/docs/combobox-option/selectionIndicator": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/selectionIndicator.tsx"))
    },
    "combobox/docs/combobox-option/description": {
        component: lazy(() => import("@/../../packages/components/src/combobox/docs/combobox-option/description.tsx"))
    },
    "tooltip/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/preview.tsx"))
    },
    "tooltip/docs/trigger": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/trigger.tsx"))
    },
    "tooltip/docs/placement": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/placement.tsx"))
    },
    "tooltip/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/disabled.tsx"))
    },
    "tooltip/docs/custom-trigger": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/custom-trigger.tsx"))
    },
    "tooltip/docs/disabled-trigger": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/disabled-trigger.tsx"))
    },
    "tooltip/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/controlled.tsx"))
    },
    "tooltip/docs/groups": {
        component: lazy(() => import("@/../../packages/components/src/tooltip/docs/groups.tsx"))
    },
    "overlays/popover/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/preview.tsx"))
    },
    "overlays/popover/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/disabled.tsx"))
    },
    "overlays/popover/docs/button": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/button.tsx"))
    },
    "overlays/popover/docs/buttons": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/buttons.tsx"))
    },
    "overlays/popover/docs/footer": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/footer.tsx"))
    },
    "overlays/popover/docs/positions": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/positions.tsx"))
    },
    "overlays/popover/docs/context": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/context.tsx"))
    },
    "overlays/popover/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/controlled.tsx"))
    },
    "modal/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/preview.tsx"))
    },
    "modal/docs/default": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/default.tsx"))
    },
    "modal/docs/image": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/image.tsx"))
    },
    "modal/docs/choice": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/choice.tsx"))
    },
    "modal/docs/header": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/header.tsx"))
    },
    "modal/docs/footer": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/footer.tsx"))
    },
    "modal/docs/button": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/button.tsx"))
    },
    "modal/docs/button-group": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/button-group.tsx"))
    },
    "modal/docs/dismissable": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/dismissable.tsx"))
    },
    "modal/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/controlled.tsx"))
    },
    "modal/docs/custom-trigger": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/custom-trigger.tsx"))
    },
    "modal/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/sizes.tsx"))
    },
    "modal/docs/responsive-sizes": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/responsive-sizes.tsx"))
    },
    "modal/docs/custom": {
        component: lazy(() => import("@/../../packages/components/src/modal/docs/custom.tsx"))
    },
    "contextual-help/docs/Preview": {
        component: lazy(() => import("@/../../packages/components/src/contextual-help/docs/Preview.tsx"))
    },
    "contextual-help/docs/Variant": {
        component: lazy(() => import("@/../../packages/components/src/contextual-help/docs/Variant.tsx"))
    },
    "contextual-help/docs/Size": {
        component: lazy(() => import("@/../../packages/components/src/contextual-help/docs/Size.tsx"))
    },
    "alert/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/preview.tsx"))
    },
    "alert/docs/default": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/default.tsx"))
    },
    "alert/docs/secondary": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/secondary.tsx"))
    },
    "alert/docs/cancel": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/cancel.tsx"))
    },
    "alert/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/disabled.tsx"))
    },
    "alert/docs/confirmation": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/confirmation.tsx"))
    },
    "alert/docs/destructive": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/destructive.tsx"))
    },
    "alert/docs/undismissable": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/undismissable.tsx"))
    },
    "alert/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/controlled.tsx"))
    },
    "alert/docs/pending": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/pending.tsx"))
    },
    "alert/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/sizes.tsx"))
    },
    "alert/docs/responsive-sizes": {
        component: lazy(() => import("@/../../packages/components/src/alert/docs/responsive-sizes.tsx"))
    },
    "tabs/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/preview.tsx"))
    },
    "tabs/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/size.tsx"))
    },
    "tabs/docs/icon": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/icon.tsx"))
    },
    "tabs/docs/lozenge": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/lozenge.tsx"))
    },
    "tabs/docs/badge": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/badge.tsx"))
    },
    "tabs/docs/dynamic": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/dynamic.tsx"))
    },
    "tabs/docs/manual": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/manual.tsx"))
    },
    "tabs/docs/variant": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/variant.tsx"))
    },
    "tabs/docs/fluid": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/fluid.tsx"))
    },
    "tabs/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/controlled.tsx"))
    },
    "tabs/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/disabled.tsx"))
    },
    "tabs/docs/disabledItems": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/disabledItems.tsx"))
    },
    "tabs/docs/disabledKeys": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/disabledKeys.tsx"))
    },
    "tabs/docs/embedded": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/embedded.tsx"))
    },
    "tabs/docs/links": {
        component: lazy(() => import("@/../../packages/components/src/tabs/docs/links.tsx"))
    },
    "link/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/preview.tsx"))
    },
    "link/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/disabled.tsx"))
    },
    "link/docs/external": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/external.tsx"))
    },
    "link/docs/noHref": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/noHref.tsx"))
    },
    "link/docs/variants": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/variants.tsx"))
    },
    "link/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/size.tsx"))
    },
    "link/docs/inheritSize": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/inheritSize.tsx"))
    },
    "link/docs/icon": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/icon.tsx"))
    },
    "link/docs/startIcon": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/startIcon.tsx"))
    },
    "link/docs/iconOnly": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/iconOnly.tsx"))
    },
    "link/docs/quiet": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/quiet.tsx"))
    },
    "link/docs/standalone": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/standalone.tsx"))
    },
    "link/docs/reactRouterLink": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/reactRouterLink.tsx"))
    },
    "link/docs/staticColor": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/staticColor.tsx"))
    },
    "link/docs/image": {
        component: lazy(() => import("@/../../packages/components/src/link/docs/image.tsx"))
    },
    "disclosure/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/preview.tsx"))
    },
    "disclosure/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/disabled.tsx"))
    },
    "disclosure/docs/variants": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/variants.tsx"))
    },
    "disclosure/docs/icon": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/icon.tsx"))
    },
    "disclosure/docs/description": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/description.tsx"))
    },
    "disclosure/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/controlled.tsx"))
    },
    "disclosure/docs/customHeader": {
        component: lazy(() => import("@/../../packages/components/src/disclosure/docs/customHeader.tsx"))
    },
    "accordion/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/preview.tsx"))
    },
    "accordion/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/disabled.tsx"))
    },
    "accordion/docs/standalone": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/standalone.tsx"))
    },
    "accordion/docs/inline": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/inline.tsx"))
    },
    "accordion/docs/multiple-selection": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/multiple-selection.tsx"))
    },
    "accordion/docs/icon": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/icon.tsx"))
    },
    "accordion/docs/description": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/description.tsx"))
    },
    "accordion/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/accordion/docs/controlled.tsx"))
    },
    "layout/docs/stack/preview": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/stack/preview.tsx"))
    },
    "layout/docs/stack/reverse": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/stack/reverse.tsx"))
    },
    "layout/docs/stack/alignX": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/stack/alignX.tsx"))
    },
    "layout/docs/stack/alignY": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/stack/alignY.tsx"))
    },
    "layout/docs/inline/preview": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/inline/preview.tsx"))
    },
    "layout/docs/inline/reverse": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/inline/reverse.tsx"))
    },
    "layout/docs/inline/alignX": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/inline/alignX.tsx"))
    },
    "layout/docs/inline/alignY": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/inline/alignY.tsx"))
    },
    "layout/docs/grid/preview": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/preview.tsx"))
    },
    "layout/docs/grid/areas": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/areas.tsx"))
    },
    "layout/docs/grid/templateColumns": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/templateColumns.tsx"))
    },
    "layout/docs/grid/autoColumns": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/autoColumns.tsx"))
    },
    "layout/docs/grid/gap": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/gap.tsx"))
    },
    "layout/docs/grid/columnSpanning": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/columnSpanning.tsx"))
    },
    "layout/docs/grid/nesting": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/nesting.tsx"))
    },
    "layout/docs/grid/repeat": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/repeat.tsx"))
    },
    "layout/docs/grid/minMax": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/minMax.tsx"))
    },
    "layout/docs/grid/fitContent": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid/fitContent.tsx"))
    },
    "layout/docs/flex/preview": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/preview.tsx"))
    },
    "layout/docs/flex/verticalAlignment": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/verticalAlignment.tsx"))
    },
    "layout/docs/flex/gap": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/gap.tsx"))
    },
    "layout/docs/flex/alignItems": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/alignItems.tsx"))
    },
    "layout/docs/flex/justifyContent": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/justifyContent.tsx"))
    },
    "layout/docs/flex/reverse": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/reverse.tsx"))
    },
    "layout/docs/flex/wrap": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/wrap.tsx"))
    },
    "layout/docs/flex/nesting": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex/nesting.tsx"))
    },
    "icons/docs/richIcon/preview": {
        component: lazy(() => import("@/../../packages/icons/docs/richIcon/preview.tsx"))
    },
    "icons/docs/richIcon/sizes": {
        component: lazy(() => import("@/../../packages/icons/docs/richIcon/sizes.tsx"))
    },
    "icons/docs/richIcon/styling": {
        component: lazy(() => import("@/../../packages/icons/docs/richIcon/styling.tsx"))
    },
    "icons/docs/richIcon/variants": {
        component: lazy(() => import("@/../../packages/icons/docs/richIcon/variants.tsx"))
    },
    "icon-list/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/icon-list/docs/preview.tsx"))
    },
    "icon-list/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/icon-list/docs/size.tsx"))
    },
    "icons/docs/icon/preview": {
        component: lazy(() => import("@/../../packages/icons/docs/icon/preview.tsx"))
    },
    "icons/docs/icon/sizes": {
        component: lazy(() => import("@/../../packages/icons/docs/icon/sizes.tsx"))
    },
    "icons/docs/icon/styling": {
        component: lazy(() => import("@/../../packages/icons/docs/icon/styling.tsx"))
    },
    "html-elements/docs/listPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/listPreview.tsx"))
    },
    "html-elements/docs/tablePreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/tablePreview.tsx"))
    },
    "html-elements/docs/spanPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/spanPreview.tsx"))
    },
    "html-elements/docs/navPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/navPreview.tsx"))
    },
    "html-elements/docs/mainPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/mainPreview.tsx"))
    },
    "html-elements/docs/imgPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/imgPreview.tsx"))
    },
    "html-elements/docs/sectionPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/sectionPreview.tsx"))
    },
    "html-elements/docs/inputPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/inputPreview.tsx"))
    },
    "html-elements/docs/headerPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/headerPreview.tsx"))
    },
    "html-elements/docs/footerPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/footerPreview.tsx"))
    },
    "html-elements/docs/buttonPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/buttonPreview.tsx"))
    },
    "html-elements/docs/divPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/divPreview.tsx"))
    },
    "html-elements/docs/asidePreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/asidePreview.tsx"))
    },
    "html-elements/docs/articlePreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/articlePreview.tsx"))
    },
    "html-elements/docs/addressPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/addressPreview.tsx"))
    },
    "html-elements/docs/aPreview": {
        component: lazy(() => import("@/../../packages/components/src/html-elements/docs/aPreview.tsx"))
    },
    "inputs/docs/text-field/preview": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/preview.tsx"))
    },
    "inputs/docs/text-field/disabled": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/disabled.tsx"))
    },
    "inputs/docs/text-field/readOnly": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/readOnly.tsx"))
    },
    "inputs/docs/text-field/error": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/error.tsx"))
    },
    "inputs/docs/text-field/clearable": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/clearable.tsx"))
    },
    "inputs/docs/text-field/sizes": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/sizes.tsx"))
    },
    "inputs/docs/text-field/labeling": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/labeling.tsx"))
    },
    "inputs/docs/text-field/description": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/description.tsx"))
    },
    "inputs/docs/text-field/iconPrefix": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/iconPrefix.tsx"))
    },
    "inputs/docs/text-field/textPrefix": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/textPrefix.tsx"))
    },
    "inputs/docs/text-field/characterCount": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/characterCount.tsx"))
    },
    "inputs/docs/text-field/maxLengthExceeded": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/maxLengthExceeded.tsx"))
    },
    "inputs/docs/text-field/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/ContextualHelp.tsx"))
    },
    "inputs/docs/text-field/fluid": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/fluid.tsx"))
    },
    "inputs/docs/text-field/debounce": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-field/debounce.tsx"))
    },
    "inputs/docs/text-area/preview": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/preview.tsx"))
    },
    "inputs/docs/text-area/disabled": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/disabled.tsx"))
    },
    "inputs/docs/text-area/readOnly": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/readOnly.tsx"))
    },
    "inputs/docs/text-area/error": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/error.tsx"))
    },
    "inputs/docs/text-area/sizes": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/sizes.tsx"))
    },
    "inputs/docs/text-area/labeling": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/labeling.tsx"))
    },
    "inputs/docs/text-area/description": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/description.tsx"))
    },
    "inputs/docs/text-area/characterCount": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/characterCount.tsx"))
    },
    "inputs/docs/text-area/maxLengthExceeded": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/maxLengthExceeded.tsx"))
    },
    "inputs/docs/text-area/rows": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/rows.tsx"))
    },
    "inputs/docs/text-area/minRows": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/minRows.tsx"))
    },
    "inputs/docs/text-area/maxRows": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/maxRows.tsx"))
    },
    "inputs/docs/text-area/verticalResize": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/verticalResize.tsx"))
    },
    "inputs/docs/text-area/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/text-area/ContextualHelp.tsx"))
    },
    "switch/docs/switch/preview": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch/preview.tsx"))
    },
    "switch/docs/switch/selected": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch/selected.tsx"))
    },
    "switch/docs/switch/nolabel": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch/nolabel.tsx"))
    },
    "switch/docs/switch/disabled": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch/disabled.tsx"))
    },
    "switch/docs/switch-field/disabled": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch-field/disabled.tsx"))
    },
    "switch/docs/switch/sizes": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch/sizes.tsx"))
    },
    "switch/docs/switch-field/sizes": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch-field/sizes.tsx"))
    },
    "switch/docs/switch/icons": {
        component: lazy(() => import("@/../../packages/components/src/switch/docs/switch/icons.tsx"))
    },
    "inputs/docs/search-field/preview": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/preview.tsx"))
    },
    "inputs/docs/search-field/disabled": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/disabled.tsx"))
    },
    "inputs/docs/search-field/readOnly": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/readOnly.tsx"))
    },
    "inputs/docs/search-field/error": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/error.tsx"))
    },
    "inputs/docs/search-field/hideClearButton": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/hideClearButton.tsx"))
    },
    "inputs/docs/search-field/sizes": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/sizes.tsx"))
    },
    "inputs/docs/search-field/labeling": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/labeling.tsx"))
    },
    "inputs/docs/search-field/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/ContextualHelp.tsx"))
    },
    "inputs/docs/search-field/description": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/description.tsx"))
    },
    "inputs/docs/search-field/debounce": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/search-field/debounce.tsx"))
    },
    "radio/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/preview.tsx"))
    },
    "radio/docs/radio-group/label": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/label.tsx"))
    },
    "radio/docs/radio-group/disabled": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/disabled.tsx"))
    },
    "radio/docs/radio-group/size": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/size.tsx"))
    },
    "radio/docs/radio-group/orientation": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/orientation.tsx"))
    },
    "radio/docs/radio-group/description": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/description.tsx"))
    },
    "radio/docs/radio-group/bordered": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/bordered.tsx"))
    },
    "radio/docs/radio-group/invalid": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/invalid.tsx"))
    },
    "radio/docs/radio-group/isFluid": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/isFluid.tsx"))
    },
    "radio/docs/radio-group/controlled": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/controlled.tsx"))
    },
    "radio/docs/radio-group/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio-group/ContextualHelp.tsx"))
    },
    "radio/docs/radio/noLabel": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio/noLabel.tsx"))
    },
    "radio/docs/radio/disabled": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio/disabled.tsx"))
    },
    "radio/docs/radio/description": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio/description.tsx"))
    },
    "radio/docs/radio/icons": {
        component: lazy(() => import("@/../../packages/components/src/radio/docs/radio/icons.tsx"))
    },
    "inputs/docs/password-field/preview": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/preview.tsx"))
    },
    "inputs/docs/password-field/disabled": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/disabled.tsx"))
    },
    "inputs/docs/password-field/readOnly": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/readOnly.tsx"))
    },
    "inputs/docs/password-field/error": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/error.tsx"))
    },
    "inputs/docs/password-field/sizes": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/sizes.tsx"))
    },
    "inputs/docs/password-field/labeling": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/labeling.tsx"))
    },
    "inputs/docs/password-field/description": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/description.tsx"))
    },
    "inputs/docs/password-field/iconPrefix": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/iconPrefix.tsx"))
    },
    "inputs/docs/password-field/textPrefix": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/textPrefix.tsx"))
    },
    "inputs/docs/password-field/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/password-field/ContextualHelp.tsx"))
    },
    "inputs/docs/number-field/preview": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/preview.tsx"))
    },
    "inputs/docs/number-field/disabled": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/disabled.tsx"))
    },
    "inputs/docs/number-field/readOnly": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/readOnly.tsx"))
    },
    "inputs/docs/number-field/sizes": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/sizes.tsx"))
    },
    "inputs/docs/number-field/labeling": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/labeling.tsx"))
    },
    "inputs/docs/number-field/description": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/description.tsx"))
    },
    "inputs/docs/number-field/iconPrefix": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/iconPrefix.tsx"))
    },
    "inputs/docs/number-field/textPrefix": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/textPrefix.tsx"))
    },
    "inputs/docs/number-field/error": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/error.tsx"))
    },
    "inputs/docs/number-field/minmax": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/minmax.tsx"))
    },
    "inputs/docs/number-field/formatting": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/formatting.tsx"))
    },
    "inputs/docs/number-field/fluid": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/fluid.tsx"))
    },
    "inputs/docs/number-field/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/inputs/docs/number-field/ContextualHelp.tsx"))
    },
    "form/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/preview.tsx"))
    },
    "form/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/disabled.tsx"))
    },
    "form/docs/validation": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/validation.tsx"))
    },
    "form/docs/nativeValidation": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/nativeValidation.tsx"))
    },
    "form/docs/ariaValidation": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/ariaValidation.tsx"))
    },
    "form/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/size.tsx"))
    },
    "form/docs/fluid": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/fluid.tsx"))
    },
    "checkbox/docs/checkbox-group/preview": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/preview.tsx"))
    },
    "checkbox/docs/checkbox-group/readonly": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/readonly.tsx"))
    },
    "checkbox/docs/checkbox-group/disabled": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/disabled.tsx"))
    },
    "checkbox/docs/checkbox-group/invalid": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/invalid.tsx"))
    },
    "checkbox/docs/checkbox-group/size": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/size.tsx"))
    },
    "checkbox/docs/checkbox-group/nolabel": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/nolabel.tsx"))
    },
    "checkbox/docs/checkbox-group/description": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/description.tsx"))
    },
    "checkbox/docs/checkbox-group/variant": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/variant.tsx"))
    },
    "checkbox/docs/checkbox-group/orientation": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/orientation.tsx"))
    },
    "checkbox/docs/checkbox-group/isFluid": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/isFluid.tsx"))
    },
    "checkbox/docs/checkbox-group/controlled": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/controlled.tsx"))
    },
    "checkbox/docs/checkbox-group/itemsDescription": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/itemsDescription.tsx"))
    },
    "checkbox/docs/checkbox-group/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox-group/ContextualHelp.tsx"))
    },
    "checkbox/docs/checkbox/preview": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/preview.tsx"))
    },
    "checkbox/docs/checkbox/nolabel": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/nolabel.tsx"))
    },
    "checkbox/docs/checkbox/checked": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/checked.tsx"))
    },
    "checkbox/docs/checkbox/indeterminate": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/indeterminate.tsx"))
    },
    "checkbox/docs/checkbox/disabled": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/disabled.tsx"))
    },
    "checkbox/docs/checkbox/readonly": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/readonly.tsx"))
    },
    "checkbox/docs/checkbox/invalid": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/invalid.tsx"))
    },
    "checkbox/docs/checkbox/size": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/size.tsx"))
    },
    "checkbox/docs/checkbox/icons": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/icons.tsx"))
    },
    "checkbox/docs/checkbox/description": {
        component: lazy(() => import("@/../../packages/components/src/checkbox/docs/checkbox/description.tsx"))
    },
    "calendar/docs/range-calendar/preview": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/preview.tsx"))
    },
    "calendar/docs/range-calendar/value": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/value.tsx"))
    },
    "calendar/docs/range-calendar/controlled": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/controlled.tsx"))
    },
    "calendar/docs/range-calendar/multi-month": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/multi-month.tsx"))
    },
    "calendar/docs/range-calendar/page-behavior": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/page-behavior.tsx"))
    },
    "calendar/docs/range-calendar/fixed-weeks": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/fixed-weeks.tsx"))
    },
    "calendar/docs/range-calendar/min-max": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/min-max.tsx"))
    },
    "calendar/docs/range-calendar/unavailable": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/unavailable.tsx"))
    },
    "calendar/docs/range-calendar/non-contiguous-ranges": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/non-contiguous-ranges.tsx"))
    },
    "calendar/docs/range-calendar/error-message": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/error-message.tsx"))
    },
    "calendar/docs/range-calendar/disabled": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/disabled.tsx"))
    },
    "calendar/docs/range-calendar/readonly": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/readonly.tsx"))
    },
    "calendar/docs/range-calendar/custom-first-day": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/range-calendar/custom-first-day.tsx"))
    },
    "date-picker/docs/date-range-picker/preview": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/preview.tsx"))
    },
    "date-picker/docs/date-range-picker/value": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/value.tsx"))
    },
    "date-picker/docs/date-range-picker/controlled": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/controlled.tsx"))
    },
    "date-picker/docs/date-range-picker/invalid": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/invalid.tsx"))
    },
    "date-picker/docs/date-range-picker/min-max": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/min-max.tsx"))
    },
    "date-picker/docs/date-range-picker/unavailable": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/unavailable.tsx"))
    },
    "date-picker/docs/date-range-picker/non-contiguous": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/non-contiguous.tsx"))
    },
    "date-picker/docs/date-range-picker/custom-validation": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/custom-validation.tsx"))
    },
    "date-picker/docs/date-range-picker/description": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/date-range-picker/description.tsx"))
    },
    "date-picker/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/preview.tsx"))
    },
    "date-picker/docs/value": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/value.tsx"))
    },
    "date-picker/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/controlled.tsx"))
    },
    "date-picker/docs/invalid": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/invalid.tsx"))
    },
    "date-picker/docs/min-max": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/min-max.tsx"))
    },
    "date-picker/docs/unavailable": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/unavailable.tsx"))
    },
    "date-picker/docs/custom-validation": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/custom-validation.tsx"))
    },
    "date-picker/docs/description": {
        component: lazy(() => import("@/../../packages/components/src/date-picker/docs/description.tsx"))
    },
    "calendar/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/preview.tsx"))
    },
    "calendar/docs/value": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/value.tsx"))
    },
    "calendar/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/controlled.tsx"))
    },
    "calendar/docs/multi-month": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/multi-month.tsx"))
    },
    "calendar/docs/page-behavior": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/page-behavior.tsx"))
    },
    "calendar/docs/fixed-weeks": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/fixed-weeks.tsx"))
    },
    "calendar/docs/min-max": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/min-max.tsx"))
    },
    "calendar/docs/unavailable": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/unavailable.tsx"))
    },
    "calendar/docs/error-message": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/error-message.tsx"))
    },
    "calendar/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/disabled.tsx"))
    },
    "calendar/docs/readonly": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/readonly.tsx"))
    },
    "calendar/docs/custom-first-day": {
        component: lazy(() => import("@/../../packages/components/src/calendar/docs/custom-first-day.tsx"))
    },
    "typography/text/docs/text/preview": {
        component: lazy(() => import("@/../../packages/components/src/typography/text/docs/text/preview.tsx"))
    },
    "typography/text/docs/text/size": {
        component: lazy(() => import("@/../../packages/components/src/typography/text/docs/text/size.tsx"))
    },
    "typography/text/docs/text/inherit": {
        component: lazy(() => import("@/../../packages/components/src/typography/text/docs/text/inherit.tsx"))
    },
    "typography/text/docs/text/nested": {
        component: lazy(() => import("@/../../packages/components/src/typography/text/docs/text/nested.tsx"))
    },
    "typography/paragraph/docs/paragraph/preview": {
        component: lazy(() => import("@/../../packages/components/src/typography/paragraph/docs/paragraph/preview.tsx"))
    },
    "typography/paragraph/docs/paragraph/size": {
        component: lazy(() => import("@/../../packages/components/src/typography/paragraph/docs/paragraph/size.tsx"))
    },
    "typography/paragraph/docs/paragraph/inherit": {
        component: lazy(() => import("@/../../packages/components/src/typography/paragraph/docs/paragraph/inherit.tsx"))
    },
    "typography/label/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/typography/label/docs/preview.tsx"))
    },
    "typography/label/docs/color": {
        component: lazy(() => import("@/../../packages/components/src/typography/label/docs/color.tsx"))
    },
    "typography/label/docs/required": {
        component: lazy(() => import("@/../../packages/components/src/typography/label/docs/required.tsx"))
    },
    "typography/label/docs/optional": {
        component: lazy(() => import("@/../../packages/components/src/typography/label/docs/optional.tsx"))
    },
    "image/docs/image": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/image.tsx"))
    },
    "image/docs/shape": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/shape.tsx"))
    },
    "image/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/size.tsx"))
    },
    "image/docs/objectFit": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/objectFit.tsx"))
    },
    "image/docs/retina": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/retina.tsx"))
    },
    "image/docs/svg": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/svg.tsx"))
    },
    "image/docs/svgSize": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/svgSize.tsx"))
    },
    "image/docs/svgColor": {
        component: lazy(() => import("@/../../packages/components/src/image/docs/svgColor.tsx"))
    },
    "illustration/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/illustration/docs/preview.tsx"))
    },
    "illustration/docs/default": {
        component: lazy(() => import("@/../../packages/components/src/illustration/docs/default.tsx"))
    },
    "illustration/docs/vertical": {
        component: lazy(() => import("@/../../packages/components/src/illustration/docs/vertical.tsx"))
    },
    "illustration/docs/shape": {
        component: lazy(() => import("@/../../packages/components/src/illustration/docs/shape.tsx"))
    },
    "illustrated-message/docs/default": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/default.tsx"))
    },
    "illustrated-message/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/size.tsx"))
    },
    "illustrated-message/docs/image": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/image.tsx"))
    },
    "illustrated-message/docs/button": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/button.tsx"))
    },
    "illustrated-message/docs/buttonGroup": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/buttonGroup.tsx"))
    },
    "illustrated-message/docs/svg": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/svg.tsx"))
    },
    "illustrated-message/docs/migration/horizontal": {
        component: lazy(() => import("@/../../packages/components/src/illustrated-message/docs/migration/horizontal.tsx"))
    },
    "typography/heading/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/typography/heading/docs/preview.tsx"))
    },
    "typography/heading/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/typography/heading/docs/sizes.tsx"))
    },
    "typography/heading/docs/levels": {
        component: lazy(() => import("@/../../packages/components/src/typography/heading/docs/levels.tsx"))
    },
    "typography/heading/docs/inherit": {
        component: lazy(() => import("@/../../packages/components/src/typography/heading/docs/inherit.tsx"))
    },
    "divider/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/divider/docs/preview.tsx"))
    },
    "divider/docs/orientation": {
        component: lazy(() => import("@/../../packages/components/src/divider/docs/orientation.tsx"))
    },
    "card/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/preview.tsx"))
    },
    "card/docs/variant": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/variant.tsx"))
    },
    "card/docs/sections": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/sections.tsx"))
    },
    "card/docs/migration/default": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/default.tsx"))
    },
    "card/docs/migration/image": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/image.tsx"))
    },
    "card/docs/migration/illustration": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/illustration.tsx"))
    },
    "card/docs/migration/size": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/size.tsx"))
    },
    "card/docs/migration/button": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/button.tsx"))
    },
    "card/docs/migration/buttongroup": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/buttongroup.tsx"))
    },
    "card/docs/migration/orientation": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/orientation.tsx"))
    },
    "card/docs/migration/fluid": {
        component: lazy(() => import("@/../../packages/components/src/card/docs/migration/fluid.tsx"))
    },
    "avatar/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/preview.tsx"))
    },
    "avatar/docs/localImage": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/localImage.tsx"))
    },
    "avatar/docs/remoteImage": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/remoteImage.tsx"))
    },
    "avatar/docs/fallbackImage": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/fallbackImage.tsx"))
    },
    "avatar/docs/brokenImage": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/brokenImage.tsx"))
    },
    "avatar/docs/brokenImageWithBothFailing": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/brokenImageWithBothFailing.tsx"))
    },
    "avatar/docs/brokenImageWithNoFallback": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/brokenImageWithNoFallback.tsx"))
    },
    "avatar/docs/anonymous": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/anonymous.tsx"))
    },
    "avatar/docs/deleted": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/deleted.tsx"))
    },
    "avatar/docs/broken": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/broken.tsx"))
    },
    "avatar/docs/sizes": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/sizes.tsx"))
    },
    "avatar/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/disabled.tsx"))
    },
    "avatar/docs/press": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/press.tsx"))
    },
    "avatar/docs/customization": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/customization.tsx"))
    },
    "avatar/docs/avatar-group/preview": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/avatar-group/preview.tsx"))
    },
    "avatar/docs/avatar-group/tooMany": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/avatar-group/tooMany.tsx"))
    },
    "avatar/docs/avatar-group/withDescription": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/avatar-group/withDescription.tsx"))
    },
    "avatar/docs/avatar-group/sizes": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/avatar-group/sizes.tsx"))
    },
    "avatar/docs/avatar-group/pressable": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/avatar-group/pressable.tsx"))
    },
    "avatar/docs/avatar-group/maxNumberOfAvatars": {
        component: lazy(() => import("@/../../packages/components/src/avatar/docs/avatar-group/maxNumberOfAvatars.tsx"))
    },
    "hopper-provider/docs/theme/apply": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/theme/apply.tsx"))
    },
    "hopper-provider/docs/theme/apply-nested": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/theme/apply-nested.tsx"))
    },
    "hopper-provider/docs/theme/changing": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/theme/changing.tsx"))
    },
    "layout/docs/flex": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/flex.tsx"))
    },
    "layout/docs/grid": {
        component: lazy(() => import("@/../../packages/components/src/layout/docs/grid.tsx"))
    },
    "form/docs/forms-concept/labels": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/forms-concept/labels.tsx"))
    },
    "form/docs/forms-concept/formData": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/forms-concept/formData.tsx"))
    },
    "form/docs/forms-concept/accessValue": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/forms-concept/accessValue.tsx"))
    },
    "form/docs/forms-concept/nativeValidation": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/forms-concept/nativeValidation.tsx"))
    },
    "form/docs/forms-concept/errorMessage": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/forms-concept/errorMessage.tsx"))
    },
    "form/docs/forms-concept/customValidation": {
        component: lazy(() => import("@/../../packages/components/src/form/docs/forms-concept/customValidation.tsx"))
    },
    "hopper-provider/docs/color-scheme/apply": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/color-scheme/apply.tsx"))
    },
    "hopper-provider/docs/color-scheme/apply-system": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/color-scheme/apply-system.tsx"))
    },
    "hopper-provider/docs/color-scheme/apply-nested": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/color-scheme/apply-nested.tsx"))
    },
    "hopper-provider/docs/color-scheme/changing": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/color-scheme/changing.tsx"))
    },
    "hopper-provider/docs/color-scheme/useColorSchemeValue": {
        component: lazy(() => import("@/../../packages/components/src/hopper-provider/docs/color-scheme/useColorSchemeValue.tsx"))
    },
    "tag/docs/tag-group/preview": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/preview.tsx"))
    },
    "tag/docs/tag-group/label": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/label.tsx"))
    },
    "tag/docs/tag-group/description": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/description.tsx"))
    },
    "tag/docs/tag-group/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/disabled.tsx"))
    },
    "tag/docs/tag-group/item/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/disabled.tsx"))
    },
    "tag/docs/tag-group/invalid": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/invalid.tsx"))
    },
    "tag/docs/tag-group/removable": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/removable.tsx"))
    },
    "tag/docs/tag-group/readonly": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/readonly.tsx"))
    },
    "tag/docs/tag-group/selectable": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/selectable.tsx"))
    },
    "tag/docs/tag-group/sizes": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/sizes.tsx"))
    },
    "tag/docs/tag-group/item/sizes": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/sizes.tsx"))
    },
    "tag/docs/tag-group/variants": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/variants.tsx"))
    },
    "tag/docs/tag-group/item/variants": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/variants.tsx"))
    },
    "tag/docs/tag-group/empty": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/empty.tsx"))
    },
    "tag/docs/tag-group/ContextualHelp": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/ContextualHelp.tsx"))
    },
    "tag/docs/tag-group/item/invalid": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/invalid.tsx"))
    },
    "tag/docs/tag-group/item/loading": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/loading.tsx"))
    },
    "tag/docs/tag-group/item/avatar": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/avatar.tsx"))
    },
    "tag/docs/tag-group/item/icons": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/icons.tsx"))
    },
    "tag/docs/tag-group/item/count": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/count.tsx"))
    },
    "tag/docs/tag-group/item/links": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/links.tsx"))
    },
    "tag/docs/tag-group/item/reactRouterLinks": {
        component: lazy(() => import("@/../../packages/components/src/tag/docs/tag-group/item/reactRouterLinks.tsx"))
    },
    "menu/docs/Preview": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Preview.tsx"))
    },
    "menu/docs/Empty": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Empty.tsx"))
    },
    "menu/docs/AlignDirection": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/AlignDirection.tsx"))
    },
    "menu/docs/Sizes": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Sizes.tsx"))
    },
    "menu/docs/Sections": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Sections.tsx"))
    },
    "menu/docs/Dividers": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Dividers.tsx"))
    },
    "menu/docs/ItemIcon": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/ItemIcon.tsx"))
    },
    "menu/docs/ItemEndIcon": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/ItemEndIcon.tsx"))
    },
    "menu/docs/ItemDescription": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/ItemDescription.tsx"))
    },
    "menu/docs/ItemDescriptionIcon": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/ItemDescriptionIcon.tsx"))
    },
    "menu/docs/ItemDescriptionAvatar": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/ItemDescriptionAvatar.tsx"))
    },
    "menu/docs/DisabledItem": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/DisabledItem.tsx"))
    },
    "menu/docs/DisabledKeys": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/DisabledKeys.tsx"))
    },
    "menu/docs/Validation": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Validation.tsx"))
    },
    "menu/docs/Selection": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Selection.tsx"))
    },
    "menu/docs/SectionLevelSelection": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/SectionLevelSelection.tsx"))
    },
    "menu/docs/CustomTrigger": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/CustomTrigger.tsx"))
    },
    "menu/docs/DynamicItems": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/DynamicItems.tsx"))
    },
    "menu/docs/Controlled": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Controlled.tsx"))
    },
    "menu/docs/OpeningModal": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/OpeningModal.tsx"))
    },
    "menu/docs/Submenu": {
        component: lazy(() => import("@/../../packages/components/src/menu/docs/Submenu.tsx"))
    },
    "list-box/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/preview.tsx"))
    },
    "list-box/docs/empty": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/empty.tsx"))
    },
    "list-box/docs/disabled": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/disabled.tsx"))
    },
    "list-box/docs/invalid": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/invalid.tsx"))
    },
    "list-box/docs/fluid": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/fluid.tsx"))
    },
    "list-box/docs/section": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/section.tsx"))
    },
    "list-box/docs/divider": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/divider.tsx"))
    },
    "list-box/docs/avatar": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/avatar.tsx"))
    },
    "list-box/docs/count": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/count.tsx"))
    },
    "list-box/docs/dynamicLists": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/dynamicLists.tsx"))
    },
    "list-box/docs/icons": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/icons.tsx"))
    },
    "list-box/docs/endIcons": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/endIcons.tsx"))
    },
    "list-box/docs/loading": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/loading.tsx"))
    },
    "list-box/docs/loadOnScroll": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/loadOnScroll.tsx"))
    },
    "list-box/docs/selection": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/selection.tsx"))
    },
    "list-box/docs/selectionIndicator": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/selectionIndicator.tsx"))
    },
    "list-box/docs/multipleSelected": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/multipleSelected.tsx"))
    },
    "list-box/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/size.tsx"))
    },
    "list-box/docs/description": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/description.tsx"))
    },
    "list-box/docs/multipleSizes": {
        component: lazy(() => import("@/../../packages/components/src/list-box/docs/multipleSizes.tsx"))
    },
    "buttons/docs/toggle-button/preview": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/preview.tsx"))
    },
    "buttons/docs/toggle-button/variant": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/variant.tsx"))
    },
    "buttons/docs/toggle-button/size": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/size.tsx"))
    },
    "buttons/docs/toggle-button/state": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/state.tsx"))
    },
    "buttons/docs/toggle-button/loading": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/loading.tsx"))
    },
    "buttons/docs/toggle-button/pending": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/pending.tsx"))
    },
    "buttons/docs/toggle-button/layout": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/layout.tsx"))
    },
    "buttons/docs/toggle-button/icon": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/icon.tsx"))
    },
    "buttons/docs/toggle-button/icons": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/icons.tsx"))
    },
    "buttons/docs/toggle-button/endIcon": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/toggle-button/endIcon.tsx"))
    },
    "tile/docs/tile-group/preview": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/preview.tsx"))
    },
    "tile/docs/tile-group/selected": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/selected.tsx"))
    },
    "tile/docs/tile-group/controlled": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/controlled.tsx"))
    },
    "tile/docs/tile-group/readonly": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/readonly.tsx"))
    },
    "tile/docs/tile-group/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/disabled.tsx"))
    },
    "tile/docs/tile-group/wrapping": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/wrapping.tsx"))
    },
    "tile/docs/tile-group/columns": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/tile-group/columns.tsx"))
    },
    "tile/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/preview.tsx"))
    },
    "tile/docs/migration/basic": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/basic.tsx"))
    },
    "tile/docs/migration/image": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/image.tsx"))
    },
    "tile/docs/migration/illustration": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/illustration.tsx"))
    },
    "tile/docs/migration/selected": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/selected.tsx"))
    },
    "tile/docs/readonly": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/readonly.tsx"))
    },
    "tile/docs/migration/disabled": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/disabled.tsx"))
    },
    "tile/docs/migration/orientation": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/orientation.tsx"))
    },
    "tile/docs/migration/controlled": {
        component: lazy(() => import("@/../../packages/components/src/tile/docs/migration/controlled.tsx"))
    },
    "segmented-control/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/preview.tsx"))
    },
    "segmented-control/docs/selected": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/selected.tsx"))
    },
    "segmented-control/docs/size": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/size.tsx"))
    },
    "segmented-control/docs/iconOnly": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/iconOnly.tsx"))
    },
    "segmented-control/docs/icon": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/icon.tsx"))
    },
    "segmented-control/docs/justified": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/justified.tsx"))
    },
    "segmented-control/docs/controlled": {
        component: lazy(() => import("@/../../packages/components/src/segmented-control/docs/controlled.tsx"))
    },
    "buttons/docs/link-button/preview": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/preview.tsx"))
    },
    "buttons/docs/link-button/variant": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/variant.tsx"))
    },
    "buttons/docs/link-button/size": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/size.tsx"))
    },
    "buttons/docs/link-button/state": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/state.tsx"))
    },
    "buttons/docs/link-button/external": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/external.tsx"))
    },
    "buttons/docs/link-button/noHref": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/noHref.tsx"))
    },
    "buttons/docs/link-button/layout": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/layout.tsx"))
    },
    "buttons/docs/link-button/icon": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/icon.tsx"))
    },
    "buttons/docs/link-button/reactRouterLink": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/reactRouterLink.tsx"))
    },
    "buttons/docs/link-button/icons": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/icons.tsx"))
    },
    "buttons/docs/link-button/endIcon": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/link-button/endIcon.tsx"))
    },
    "buttons/docs/button-group/preview": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button-group/preview.tsx"))
    },
    "buttons/docs/button-group/orientation": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button-group/orientation.tsx"))
    },
    "buttons/docs/button-group/alignment": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button-group/alignment.tsx"))
    },
    "buttons/docs/button-group/disabled": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button-group/disabled.tsx"))
    },
    "buttons/docs/button-group/fluid": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button-group/fluid.tsx"))
    },
    "buttons/docs/button-group/sizes": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button-group/sizes.tsx"))
    },
    "buttons/docs/button/preview": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/preview.tsx"))
    },
    "buttons/docs/button/variant": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/variant.tsx"))
    },
    "buttons/docs/button/size": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/size.tsx"))
    },
    "buttons/docs/button/state": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/state.tsx"))
    },
    "buttons/docs/button/loading": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/loading.tsx"))
    },
    "buttons/docs/button/pending": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/pending.tsx"))
    },
    "buttons/docs/button/layout": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/layout.tsx"))
    },
    "buttons/docs/button/icon": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/icon.tsx"))
    },
    "buttons/docs/button/icons": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/icons.tsx"))
    },
    "buttons/docs/button/endIcon": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/endIcon.tsx"))
    },
    "buttons/docs/button/dos-and-donts/punctuation-do": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/dos-and-donts/punctuation-do.tsx"))
    },
    "buttons/docs/button/dos-and-donts/punctuation-dont": {
        component: lazy(() => import("@/../../packages/components/src/buttons/docs/button/dos-and-donts/punctuation-dont.tsx"))
    },
    "overlays/popover/docs/popover-base/preview": {
        component: lazy(() => import("@/../../packages/components/src/overlays/popover/docs/popover-base/preview.tsx"))
    },
    "helper-message/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/helper-message/docs/preview.tsx"))
    },
    "helper-message/docs/noicon": {
        component: lazy(() => import("@/../../packages/components/src/helper-message/docs/noicon.tsx"))
    },
    "error-message/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/error-message/docs/preview.tsx"))
    },
    "error-message/docs/noicon": {
        component: lazy(() => import("@/../../packages/components/src/error-message/docs/noicon.tsx"))
    },
    "error-message/docs/multipleerrors": {
        component: lazy(() => import("@/../../packages/components/src/error-message/docs/multipleerrors.tsx"))
    },
    "box/docs/preview": {
        component: lazy(() => import("@/../../packages/components/src/box/docs/preview.tsx"))
    },
};
    